import { EVENTS } from '../../../shared/config';
import ComponentMixin from '../../../shared/mixins/ComponentMixin';
import { formatUrl, customMergeDeep, objectToFormData, encodeUrlParams, isFunction, unsetPath, uniqueId } from '@config/utils';


export default {
    mixins: [
        ComponentMixin,
    ],
    provide () {
        return { 'parentValidator': this.$validator }
    },
    props: {
        moduleCode: {
            type: String,
            require: true,
            default: null
        },
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        eventShow: {
            type: String,
            default: null,
        },
        eventClose: {
            type: String,
            default: null,
        },
        labelDateFormat: {
            type: String,
            default: 'DD/MM/YYYY',
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD HH:mm:ss',
        },
    },
    data() {
        return {
            idPanel: null,
            translateID: null,
            vScope: 'form',
            showModal: false,
            form: {
                id: null,
                code: null,
            },
            // lists: {
            //     loaded: false,
            // },
            actions: {
                show: false,
                create: false,
                edit: false,
                delete: false,
                export: false,
            },
            excludeFromSave: [],
            callback: null,
        }
    },
    created() {
        if(this.eventShow) {
            this.$eventBus.listen(this.moduleCode, this.eventShow, this.onOpenModal);
        }
        if(this.eventClose) {
            this.$eventBus.listen(this.moduleCode, this.eventClose, this.onCloseModal);
        }
    },
    beforeDestroy() {
        if(this.eventShow) {
            this.$eventBus.remove(this.moduleCode, this.eventShow, this.onOpenModal);
        }
        if(this.eventClose) {
            this.$eventBus.remove(this.moduleCode, this.eventClose, this.onCloseModal);
        }
        // this.onBeforeDestroy();
    },
    computed: {
        additional() {
            return {
                actions: this.actions,
            }
        },
        baseTranslateID() {
            return this.translateID;
        },
        modalTitle() {
            return this.$tc(`${this.translateID}.title_modal`, this.form.code ? 2 : 1, { code: this.form.code })
        },
        enableAdd() {
            return this.checkPermission(this.acl, 'add');
        },
        allowCreate() {
            return !!(this.enableAdd && !this.form.id);
        },
        allowEdit() {
            return !!(this.actions.edit && this.form.id) || this.allowCreate;
        },
        allowDelete() {
            return !!(this.actions.delete && this.form.id);
        },
        allowExport() {
            return !!(this.actions.export && this.form.id);
        },
        readonlyFormItem() {
            return !this.allowEdit;
        },
        exportFormats() {
            return [];
        },
        buttons() {
            return [
                {
                    id: 'save',
                    name: this.fnSave ? `${this.translateID}.buttons.confirm` : `${this.translateID}.buttons.save`,
                    fn: (evt) => this.saveItem(evt, this.form, [], this.fnSave),
                    active: this.allowEdit,
                    order: 1,
                    status: true,
                    class: ['btn-main'],
                    divClass: ['order-1', 'order-sm-4'],
                },
                {
                    id: 'cancel',
                    name: `${this.translateID}.buttons.cancel`,
                    fn: (evt) => this.cancelItem(evt),
                    active: this.fnSave,
                    order: 1,
                    status: true,
                    class: ['btn-outline-main'],
                    divClass: ['order-2', 'order-sm-3'],
                },
                {
                    id: 'export',
                    name: `${this.translateID}.buttons.export`,
                    fn: (evt) => this.exportItem(evt),
                    active: this.allowExport,
                    order: 1,
                    status: false,
                    class: ['btn-outline-silver'],
                    divClass: ['order-3', 'order-sm-2'],
                },
                {
                    id: 'delete',
                    name: `${this.translateID}.buttons.delete`,
                    fn: (evt) => this.deleteItem(evt),
                    active: this.allowDelete,
                    order: 1,
                    status: true,
                    class: ['btn-outline-pink'],
                    divClass: ['order-4', 'order-sm-1'],
                },
            ];
        },
        activeButtons() {
            return this.buttons.filter(b => b.status && b.active).sort(b => b.order);
        },
    },
    methods: {
        setVisibilityModal(flag) {
            this.showModal = flag;
        },
        async loadLists(data = {}, lists = {}) {
            const {id, ...rest} = data;

            let url = this.url.lists;
            if (!url) {
                return Promise.resolve(true);
            }

            if (!lists.loaded) {
                return await this.$http.get(formatUrl(url, {id}))
                .then(({data}) => {
                    Object.keys(data).forEach(key => {
                        if(key in lists) {
                            lists[key] = data[key];
                        }
                    });
                    lists.loaded = true;
                    return lists;
                })
                .catch(error => {
                    lists.loaded = false;
                    this.showHttpError(error);
                    return false;
                })
            }else{
                return Promise.resolve(lists);
            }
        },
        async loadData(data = {}) {
            const {id, code, _new = false, _updated = false, ...rest} = data;
            const urlDefault = this.url.default;

            if(_new || _updated || (!(id || code) && !urlDefault)) {
                this.setVisibilityModal(true);
                customMergeDeep(this.form, data);
                return Promise.resolve(true);
            }

            let url = formatUrl(
                id ? this.url.showDetails : (code ? this.url.showDetailsByCode : urlDefault),
                {...data}
            );

            if(!url) return Promise.resolve(false);

            return await this.$http.get(encodeUrlParams(url, 'data'))
            .then(res => {
                let _data = res.data?.data ?? {};
                let _actions = res.data?.actions ?? {};
                customMergeDeep(this.form, _data);
                customMergeDeep(this.actions, _actions);
                return true;
            }).catch(error => {
                this.showHttpError(error);
                this.closeModal({error: error});
                return false;
            });
        },
        async saveItem(evt, data = {}, exclude = [], fnSave = null) {
            let id = data.id;
            let url = id ? this.url.update : this.url.create;
            if(this.allowEdit && url) {
                this.clearMessages();

                exclude = [...exclude, ...this.excludeFromSave];
                return await this.$validator.validateAll(this.vScope)
                .then(result => {
                    if(result){
                        let _action = id ? EVENTS.UPDATED : EVENTS.CREATED;

                        if(fnSave && isFunction(fnSave)) {
                            let _data = unsetPath(data, exclude) ?? {};
                            console.log(this.additionalDataOnCreate)
                            let evtData = {action: id ? EVENTS.UPDATED_VIRTUAL : EVENTS.CREATED_VIRTUAL, data: {..._data, id, ...(this.additionalDataOnCreate ?? {})}};
                            if(!id) {
                                if(!evtData.data._new) {
                                    evtData.data['_new'] = uniqueId();
                                }
                            }else{
                                evtData.data['_updated'] = true;
                            }
                            fnSave(evtData);
                            this.closeModal(evtData);
                            return _data;
                        }

                        let formData = objectToFormData(data,
                            null,
                            null,
                            null,
                            exclude
                        );

                        if(formData){
                            if(id) {
                                formData.append('_method', 'PUT');
                            }

                            return this.$http.post(
                                formatUrl(url, {id}),
                                formData,
                                { headers: {'Content-Type': 'multipart/form-data'} }
                            ).then( res => {
                                let _data = res.data;
                                this.closeModal({action: _action, data: {...(_data?.model ?? data), id: (_data?.model?.id ?? id)}});
                                this.showMessage(_data?.data, this.modalTitle);
                                return _data;
                            }).catch(error =>{
                                this.showHttpError(error);
                                return false;
                            });
                        }
                        return Promise.resolve(false);

                    }else{
                        this.showError(this.$t('global.msg.error.form'), this.modalTitle);
                        return Promise.resolve(false);
                    }
                });
            }
            return Promise.resolve(false);
        },
        deleteItem(evt, fnSave = null) {
            let url = this.url.delete;
            if(this.allowDelete && url) {
                let id = this.form.id;
                let code = this.form.code;
                this.$root.$emit('openConfirmation', {
                    id: id,
                    data: null,
                    text: this.$t(`${this.translateID}.msg.confirm-delete`, {code: code}),
                    callback: (id) => {
                        this.clearMessages();

                        if(fnSave && isFunction(fnSave)) {
                            let evtData = {action: EVENTS.DELETED_VIRTUAL, data: {...this.form, id, code}};
                            if(!id) {
                                evtData.data['_deleted'] = true;
                            }
                            fnSave(evtData);
                            this.closeModal(evtData);
                            return;
                        }

                        this.$http.delete(formatUrl(url, {id}))
                        .then(res => {
                            this.showMessage(res.data?.data);
                            this.closeModal({action: EVENTS.DELETED, data: {...this.form, id, code}});
                        }).catch(error =>{
                            this.showHttpError(error);
                        })
                    }
                });
            }
        },
        exportItem(args, evt) {
            const {id = this.form.id, code = this.form.code, format = this.exportFormats.find(e => true)} = args;
            let url = this.url.export;
            if(!url || !format) return false;

            if(this.allowExport) {
                this.$root.$emit('openExport', {
                    confirmExport: true,
                    confirmMessage: this.$t(`${this.translateID}.msg.export.confirm`, {id, code, format: this.$t(format?.name)}),
                    title: this.modalTitle,
                    text: `${this.translateID}.msg.export.processing`,
                    finalText: `${this.translateID}.msg.export.processed`,
                    urlExport: formatUrl(url, {id: id, format: format?.format, type: format?.type}),
                    urlJob: this.url.job,
                    options: {},
                    callback: (data) => {
                    },
                });
            }
        },
        cancelItem() {
            this.onCloseModal({directAction: true});
        },
        async onLoadData(data = {}, actions = {}, readonly = false) {
            return await this.loadData(data)
            .then(res => {
                if(res) {
                    customMergeDeep(this.actions, actions);

                    if(readonly) {
                        Object.keys(this.actions)
                        .forEach(action => {
                            this.actions[action] = false;
                        })
                    }
                }
                return res;
            })
            .then(res => {
                if(res) {
                    this.setVisibilityModal(true);
                }
            });
        },
        onCloseModal(params){
            const {directAction=false, ...rest} = {...params};
            this.closeModal({directAction, ...rest});
        },
        closeModal(params = {}) {
            const {directAction=true, ...rest} = {...params};

            let evtData = {
                ...rest
            };

            this.setVisibilityModal(false);

            if(!directAction){
                if(this.eventClose) {
                    this.$eventBus.publish(this.moduleCode, this.eventClose, evtData);
                }
            }else{
                if(this.eventClosed) {
                    this.$eventBus.publish(this.moduleCode, this.eventClosed, evtData);
                }
            }

            if(this.callback && isFunction(this.callback)) {
                this.callback(evtData);
            }

            this.reset();
        },
        reset() {
            Object.assign(this.$data.form, this.$options.data().form);
            this.resetFieldValidator();
        }
    },
}